<button (click)="onOpenActivationModal(spidActivationModal, spidEidupActivationModal, spidActivationModalFooter, spidEidupModalFooter)"
i18n="Identity.ActivateIdentity.ActivateIdentity|label for activate identity@@Identity.ActivateIdentity.ActivateIdentity"
nz-button nzType="primary" *ngIf="isVisible" style="width: 100%">Attiva identità SPID</button>

<ng-template #spidActivationModal let-params let-ref="modalRef">
    <span i18n="Identity.ActivateIdentity.ModalText|modal text in activate identity page@@Identity.ActivateIdentity.ModalText"
    >Inserisci nei campi sottostanti il codice OTP ricevuto tramite SMS al numero rilasciato in fase
      di registrazione </span>

    <nz-spin i18n-nzTip="Auth.Generic.SpinnerText|text in spinner@@Auth.Generic.SpinnerText"
    nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
      <form autocomplete="off" nz-form class="custom-form" [formGroup]="validateForm">
        <nz-form-item class="login">
          <div nz-row>
            <div nz-col nzSpan="24">
              <nz-form-control nzHasFeedback [nzValidateStatus]="otpCode" [nzErrorTip]="getValidationErrorMessage(validateForm.controls.otpCode.errors)">
                <nz-input-group nzPrefixIcon="lock" class="login">
                  <input nz-input type="password" formControlName="otpCode"
                  i18n-placeholder="Identity.EditIdentity.PlaceholderOTPCode|placeholder for otp code in form@@Identity.EditIdentity.PlaceholderOTPCode"
                  placeholder="Codice OTP">
                </nz-input-group>
              </nz-form-control>
            </div>
          </div>
        </nz-form-item>
      </form>
    </nz-spin>
</ng-template>

<ng-template #spidActivationModalFooter>
  <div nz-row nzAlign="middle" nzJustify="space-between">
      <div nz-col [nzSpan]="16">
          <a *ngIf="!timerService.otpSended"
          i18n="Identity.Generic.RequestNewOTP|generic request new otp label@@Identity.Generic.RequestNewOTP"
          (click)="requestNewOTP()">Richiedi nuovo invio OTP </a>
          <a *ngIf="timerService.otpSended"> Richiedi un nuovo OTP tra {{ timerService.timer }} secondi. </a>
      </div>
      <div nz-col [nzSpan]="8">
          <button nz-button nzType="primary" i18n="Generic.Send|label for send button@@Generic.Send"
          (click)="onActivateIdentity()" [disabled]="!validateForm.valid">INVIA</button>
      </div>
    </div>
</ng-template>

<ng-template #spidEidupActivationModal let-params let-ref="modalRef">
  <span i18n="Identity.ActivateIdentity.ModalText|modal text in activate identity page@@Identity.ActivateIdentity.ModalText"
  >Inserisci nei campi sottostanti il token ricevuto, il token di controllo e l'OTP. </span>

  <nz-spin i18n-nzTip="Auth.Generic.SpinnerText|text in spinner@@Auth.Generic.SpinnerText"
  nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
  <form autocomplete="off" nz-form class="custom-form" [formGroup]="eidupValidateForm">
    <nz-form-item>
      <div nz-row>
        <div nz-col nzSpan="24">
          <nz-form-control nzHasFeedback [nzValidateStatus]="eidupValidateForm.controls.token">
            <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="tokenTemplate">
              <input nz-input [type]="tokenVisible ? 'text' : 'password'" formControlName="token"
              i18n-placeholder="Identity.EditIdentity.PlaceholderToken|placeholder for token in form@@Identity.EditIdentity.PlaceholderToken"
              placeholder="Token" >
            </nz-input-group>
            <ng-template #tokenTemplate>
              <i nz-icon [nzType]="tokenVisible ? 'eye-invisible' : 'eye'"
              (click)="tokenVisible = !tokenVisible"></i>
          </ng-template>
          </nz-form-control>
        </div>
      </div>
    </nz-form-item>
    <nz-form-item>
      <div nz-row>
        <div nz-col nzSpan="24">
          <nz-form-control nzHasFeedback nzErrorTip="Inserire un valore numerico con tre cifre univoche" [nzValidateStatus]="eidupValidateForm.controls.controlCode">
            <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="controlCodeTemplate">
              <input nz-input [type]="controlCodeVisible ? 'text' : 'password'" formControlName="controlCode"
              i18n-placeholder="Identity.EditIdentity.PlaceholderControlCode|placeholder for control code in form@@Identity.EditIdentity.PlaceholderControlCode"
              placeholder="Codice di controllo" >
            </nz-input-group>
            <ng-template #controlCodeTemplate>
              <i nz-icon [nzType]="controlCodeVisible ? 'eye-invisible' : 'eye'"
              (click)="controlCodeVisible = !controlCodeVisible"></i>
          </ng-template>
          </nz-form-control>
        </div>
      </div>
    </nz-form-item>
    <app-resend-otp class="withPadding"
      [disabled]="timerService.otpSended || !eidupValidateForm.controls.token.valid || !eidupValidateForm.controls.controlCode.valid"
      [validateForm]="eidupValidateForm"
      [errorTip]="getValidationErrorMessage(eidupValidateForm.controls.otpCode.errors)"
      (isSpinning)="activateSpin($event)"
    ></app-resend-otp>
    </form>
  </nz-spin>
</ng-template>

<ng-template #spidEidupModalFooter>
  <div nz-row nzAlign="middle" nzJustify="end">
      <div nz-col [nzSpan]="8">
          <button nz-button nzType="primary" i18n="Generic.SendEidup|label for send eidup button@@Generic.SendEidup"
          (click)="onActivateEidupIdentity()" [disabled]="!eidupValidateForm.valid">INVIA</button>
      </div>
    </div>
</ng-template>
